<template>
  <div>
    <ContentWrapperControl>
      <div class="bg-white p-4 rounded-b shadow overflow-hidden mb-4">
        <div
          v-text="lang('lbl_0000262')"
          class="text-sm leading-normal text-grey-darkest"
        ></div>
      </div>
      <div class="bg-white p-4 rounded shadow">
        <div>
          <PinControl
            @typing="typing"
            @complete="complete"
            v-bind:value="pin"
            v-bind:label="lang('lbl_0000032')"
          />
        </div>
        <div class="px-4 pb-4">
          <ButtonControl v-on:click="next" v-bind:disabled="disabled">
            {{ lang("lbl_0000033") }}
          </ButtonControl>
        </div>
      </div>
    </ContentWrapperControl>
  </div>
</template>

<script>
import ContentWrapperControl from "./../../components/controls/ContentWrapperControl.vue";
import PinControl from "@/components/controls/PinControl.vue";
import ButtonControl from "@/components/controls/ButtonControl.vue";
import mixin from "./../../mixin.js";
import User from "@/services/User";

export default {
  mixins: [mixin],
  components: {
    ContentWrapperControl,
    PinControl,
    ButtonControl,
  },
  data() {
    return {
      type: 3,
      email: null,
      mobile: null,
      name: null,
      otp_pin: null,
      pin: "",
      disabled: true,
    };
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("nofooter", true);
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000069"),
      show: true,
      back: true,
    });

    let state = this.$store.state;

    if (state.deactivate.hash == null) {
      this.$router.push("/settings/deactivate");
    }

    this.email = state.info.email;
    this.mobile = state.info.mobile_no;
    this.name = state.info.first_name;
    this.otp_pin = state.deactivate.otp.pin;
  },
  methods: {
    complete(pin) {
      this.pin = pin;
    },
    typing(pin) {
      this.pin = pin;
      this.disabled = this.pin.length < 6;
    },
    next() {
      this.$emit("showloader");
      let state = this.$store.state;
      let that = this;
      User.validatePin(state.uuid, this.pin)
        .then(function () {
          that.$router.push("/settings/deactivate/verify");
          that.$emit("hideloader");
        })
        .catch(function (error) {
          that.$emit("error", error);
        });
    },
    failed(message) {
      this.$emit("alert", {
        theme: "error",
        title: this.lang("lbl_0000034"),
        message: message,
      });
    },
    showloader() {
      this.$emit("showloader");
    },
    hideloader() {
      this.$emit("hideloader");
    },
  },
};
</script>
